import { FC, ReactElement } from 'react';
import { render as reactTestingRender, RenderOptions } from '@testing-library/react';

const AllTheProviders: FC<any> = ({ children }) => {
  //TODO: Add all the needed providers
  return <>{children}</>;
};

const customRender: any = (ui: ReactElement<any>, options?: Omit<RenderOptions, 'wrapper'>) =>
  reactTestingRender(ui, { wrapper: AllTheProviders, ...options });

export * from '@testing-library/react';
export { customRender as render };
